import React, { useState, Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Spinner from "../layout/Spinner";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getStates, getDistrict, getBlockDetails } from "../../actions/area";
import {

  getASSAIncomeAndExpenseReport,
  getExcessPayDataForIncomeAndExpense,
  getAssaSurplusAndDeficit,
} from "../../actions/shg";
import { CSVLink } from "react-csv";

const IncomeExpenseTallyReport = ({
  auth: { isAuthenticated, user, users },
  shg: {

    ASSAincomeandexpensereport,
    loadStatus,
    surplusDeficit,
  },
  area: { statesData, activeDistrict, getBlock },
  getStates,
  getDistrict,
  getBatchOfDistrict,
  getBlockDetails,
  getAllBatchesDropdown,
  getAssaSurplusAndDeficit,
  getASSAIncomeAndExpenseReport,
  getExcessPayDataForIncomeAndExpense,
}) => {

  useEffect(() => {
    getASSAIncomeAndExpenseReport();
    getAssaSurplusAndDeficit();
    getExcessPayDataForIncomeAndExpense();
  }, [getASSAIncomeAndExpenseReport]);

  ///////////////////Permission////////////////

  // console.log("surplusDeficit",surplusDeficit)
  let loggedUserInstitutionData = JSON.parse(
    localStorage.getItem("loggedUserInstitutionData"),
  );


  let fiscalyearstart = "",
    fiscalyearend = "";
  let today = new Date();

  if (today.getMonth() + 1 <= 3) {
    fiscalyearstart = today.getFullYear() - 1 + "-04-01";
    fiscalyearend = today.getFullYear() + "-03-31";
  } else {
    fiscalyearstart = today.getFullYear() + "-04-01";
    fiscalyearend = today.getFullYear() + 1 + "-03-31";
  }
  const [fromSelectedDate, setBatchDate] = useState(fiscalyearstart);
  const [toSelectedDate, setBatchDates] = useState(fiscalyearend);

  /////////Income Total/////////////
  const incomeTotal = (incomeTotal) => {

    const incomeData =
      Number(incomeTotal.batchInterestPaid) +
      Number(incomeTotal.batchOtherLoanInterestShg) +
      Number(incomeTotal.batchSubAmt) +
      Number(incomeTotal.subsidyReceived) +
      Number(incomeTotal.batchOtherContribution) +
      Number(incomeTotal.batchOtherIncome) +
      Number(incomeTotal.bankInterest) +
      Number(incomeTotal.seedMoney)
      +

      Number((surplusDeficit && Math.abs(surplusDeficit.deficit)) || 0)
    return Math.round(incomeData * 100) / 100

  };
  /////////////Expense Total/////////////////
  const expenseTotal = (expenseTotal) => {

    const expenseData =
      Number(expenseTotal.batchOtherLoanInterestDonor) +
      Number(expenseTotal.bankCommission) +
      Number(expenseTotal.donationToOutsider) +
      Number(expenseTotal.stationaryExpenses) +
      Number(expenseTotal.otherExpenses) +
      Number(expenseTotal.travellingExpenses) +
      Number(expenseTotal.batchDividendDistributed) +
      Number((surplusDeficit && surplusDeficit.surplus) || 0)


    return Math.round(expenseData * 100) / 100

  };
  ////////////////////Excel report//////////////////////

  const csvData = [
    [
      "Interest On Internal Loan (Members)",
      "Interest On Other Loans (Members)",
      "Members Subscription",
      "Bank Subsidy",
      "Donations Received",
      "Other Income",
      "SB Interest",
      "Seed Money",
      "",
      "Interest On OL (SHG)",
      "Bank Charges",
      "Donations Given",
      "Printing and Stationery",
      "Other Expenses",
      "Travel and Misc expenses",
      "Dividend Distributed",
      "Deficit",
      "Surplus",
    ],
  ];

  if (ASSAincomeandexpensereport)
    csvData.push([
      ASSAincomeandexpensereport.batchInterestPaid,
      ASSAincomeandexpensereport.batchOtherLoanInterestShg,
      ASSAincomeandexpensereport.batchSubAmt,
      ASSAincomeandexpensereport.subsidyReceived,
      ASSAincomeandexpensereport.batchOtherContribution,
      ASSAincomeandexpensereport.batchOtherIncome,
      ASSAincomeandexpensereport.bankInterest,
      ASSAincomeandexpensereport.seedMoney,
      "",
      //expense
      ASSAincomeandexpensereport.batchOtherLoanInterestDonor,
      ASSAincomeandexpensereport.bankCommission,
      ASSAincomeandexpensereport.donationToOutsider,
      ASSAincomeandexpensereport.stationaryExpenses,
      ASSAincomeandexpensereport.otherExpenses,
      ASSAincomeandexpensereport.travellingExpenses,
      ASSAincomeandexpensereport.batchDividendDistributed,
      surplusDeficit && surplusDeficit.deficit,
      surplusDeficit && surplusDeficit.surplus,
    ]);

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      {loadStatus ?
        (
          <Spinner />
        )
        :
        (
          <div className="container container_align ">
            <div className="col-lg-11 col-md-11 col-sm-11 col-11">
              <h2 className="heading_color">Income & Expenses Report</h2>
              <hr />
            </div>
            {ASSAincomeandexpensereport ? (
              <section className="sub_reg">


                <div className="row col-lg-11 col-md-11 col-sm-11 col-11 no_padding">
                  <>
                    <div className="col-lg-4 col-md-5 col-sm-4 col-11 mt-1">
                      <label className="label-control"><b>State:</b> {ASSAincomeandexpensereport.stateName}</label>
                      {/* <p className="assettallyReport">StateName:{ASSAAssetAndLiability.stateName}</p> */}
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-4 col-11 mt-1">
                      <label className="label-control"><b>District:</b> {ASSAincomeandexpensereport.districtName}</label>
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-4 col-11 mt-1">
                      <label className="label-control"><b>Block:</b> {ASSAincomeandexpensereport.blockName}</label>
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-4 col-3 mt-1">
                      <label className="label-control"><b>Date:</b> {toSelectedDate}</label>
                      {/* <input
                            type="date"
                            placeholder="dd/mm/yyyy"
                            className="form-control cpp-input datevalidation"
                            name="toDate"
                            value={toSelectedDate}
                            style={{
                              width: "75%",
                            }}
                            disabled
                          /> */}
                    </div>
                    <div className="col-lg-5 col-md-5 col-sm-4 col-3 mt-1">
                      <label className="label-control"><b>Batch:</b> {ASSAincomeandexpensereport.batchName}</label>
                    </div>

                  </>
                </div>
                <div className="row col-lg-11 col-md-11 col-sm-11 col-11 no_padding mt-2">

                  <div className="col-lg-4 col-md-5 col-sm-4 col-11 ">


                  </div>
                  <div className="col-lg-8 col-md-3 col-sm-4 col-11 py-3">


                    <Link to="/TallyReport">
                      <img
                        className="img_icon_size log float-right ml-3"
                        src={require("../../static/images/back.png")}
                        alt="Back"
                        title="Back"
                      />
                    </Link>


                    {/* <img
                            className="img_icon_size log float-right ml-3"
                            onClick={() => onClickReset()}
                            src={require("../../static/images/refresh-icon.png")}
                            alt="refresh"
                            title="Refresh"
                          /> */}
                    <CSVLink data={csvData}>
                      <img
                        className="img_icon_size log float-right ml-4"
                        src={require("../../static/images/ExcelIcon.png")}
                        alt="Excel-Export"
                        title="Excel-Export"
                      />
                    </CSVLink>
                  </div>
                </div>



                <div className="row col-lg-11 col-md-11 col-sm-11 col-11 "></div>
                <div className="row col-11">
                  <div className="col-lg-6 col-md-11 col-sm-11 col-11">
                    <div className=" body-inner no-padding table-responsive ">
                      <h4>
                        <center>
                          <b> INCOME</b>
                        </center>
                      </h4>
                      <table
                        className="table table-bordered table-striped table-hover"
                        id="datatable2"
                      >
                        <thead>
                          <tr>
                            <th>Income</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr>
                            <td>Interest On Internal Loan (Members)</td>
                            <td>
                              {ASSAincomeandexpensereport.batchInterestPaid}
                            </td>
                          </tr>
                          <tr>
                            <td>Interest On Other Loans (Members)</td>
                            <td>
                              {
                                ASSAincomeandexpensereport.batchOtherLoanInterestShg
                              }
                            </td>
                          </tr>
                          <tr>
                            <td>Members Subscription</td>
                            <td>{ASSAincomeandexpensereport.batchSubAmt}</td>
                          </tr>
                          <tr>
                            <td>Bank Subsidy</td>
                            <td>
                              {ASSAincomeandexpensereport.subsidyReceived}
                            </td>
                          </tr>
                          <tr>
                            <td>Donations Received</td>
                            <td>
                              {
                                ASSAincomeandexpensereport.batchOtherContribution
                              }
                            </td>
                          </tr>
                          <tr>
                            <td>Other Income</td>
                            <td>
                              {ASSAincomeandexpensereport.batchOtherIncome}
                            </td>
                          </tr>
                          <tr>
                            <td>SB Interest</td>
                            <td>{ASSAincomeandexpensereport.bankInterest}</td>
                          </tr>
                          <tr>
                            <td>Seed Money</td>
                            <td>{ASSAincomeandexpensereport.seedMoney}</td>
                          </tr>

                          {/* <tr>
                            <td>Excess Amount from OL</td>
                            <td>
                              {(excessPaymentForIncomeAndExpense &&
                                excessPaymentForIncomeAndExpense.excessPayment) ||
                                0}
                            </td>
                          </tr> */}
                          {surplusDeficit && surplusDeficit.deficit != 0 ? (
                            <tr>
                              <td>
                                <b>Deficit</b>
                              </td>
                              <td>
                                {surplusDeficit && Math.round(Math.abs(surplusDeficit.deficit) * 100) / 100}

                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}

                          <tr>
                            <td>
                              <b>Total</b>
                            </td>
                            <td>
                              <b>{incomeTotal(ASSAincomeandexpensereport)}</b>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-11 col-sm-11 col-11 ">
                    <h4>
                      <center>
                        <b> EXPENSE </b>
                      </center>
                    </h4>

                    <div className=" body-inner no-padding table-responsive ">
                      <table
                        className="table table-bordered table-striped table-hover"
                        id="datatable2"
                      >
                        <thead>
                          <tr>
                            <th width="60%">Expense</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            <tr>
                              <td> Interest On OL (SHG)</td>
                              <td>
                                {
                                  ASSAincomeandexpensereport.batchOtherLoanInterestDonor
                                }
                              </td>
                            </tr>
                            <tr>
                              <td>Bank Charges</td>
                              <td>{ASSAincomeandexpensereport.bankCommission}</td>
                            </tr>
                            <tr>
                              <td> Donations Given</td>
                              <td>
                                {ASSAincomeandexpensereport.donationToOutsider}
                              </td>
                            </tr>
                            <tr>
                              <td> Printing and Stationery</td>
                              <td>
                                {ASSAincomeandexpensereport.stationaryExpenses}
                              </td>
                            </tr>
                            <tr>
                              <td> Other Expenses</td>
                              <td>{ASSAincomeandexpensereport.otherExpenses}</td>
                            </tr>
                            <tr>
                              <td>Travel and Misc expenses</td>
                              <td>
                                {ASSAincomeandexpensereport.travellingExpenses}
                              </td>
                            </tr>
                            <tr>
                              <td> Dividend Distributed</td>
                              <td>
                                {
                                  ASSAincomeandexpensereport.batchDividendDistributed
                                }
                              </td>
                            </tr>

                            {surplusDeficit && surplusDeficit.surplus != 0 ? (
                              <tr>
                                <td>
                                  <b>Surplus</b>
                                </td>
                                <td>
                                  {surplusDeficit && Math.round((surplusDeficit.surplus) * 100) / 100}
                                </td>
                              </tr>
                            ) : (
                              <></>
                            )}

                            <tr>
                              <td>
                                <b>Total</b>
                              </td>
                              <td>
                                <b>{expenseTotal(ASSAincomeandexpensereport)}</b>
                              </td>
                            </tr>
                          </>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>




              </section>
            ) : (
              <></>
            )
            }
          </div >
        )}

    </Fragment >
  );
};
IncomeExpenseTallyReport.prototypes = {
  auth: PropTypes.object.isRequired,
  shg: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  getAllBatchesDropdown: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  shg: state.shg,
});
export default connect(mapStateToProps, {

  getASSAIncomeAndExpenseReport,
  getAssaSurplusAndDeficit,
  getExcessPayDataForIncomeAndExpense,
})(IncomeExpenseTallyReport);
